
import { Icon } from '@/lib/enum/Icon';
import VueI18n from 'vue-i18n';
import TranslateResult = VueI18n.TranslateResult;

export default {
  name: 'FetchAutoComplete',

  inheritAttrs: false,

  props: {
    items: {
      type: Array,
      required: true,
    },

    labelText: {
      type: [String, TranslateResult],
      default: '',
    },

    placeholder: {
      type: String,
      default: '',
    },

    noDataText: {
      type: String,
      default: '$vuetify.noDataText',
    },

    itemText: {
      type: String,
      default: 'name',
    },

    itemValue: {
      type: String,
      default: 'id',
    },

    value: {
      type: [Array, Number],
      default: null,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    readOnly: {
      type: Boolean,
      default: false,
    },

    required: {
      type: Boolean,
      default: false,
    },

    multiple: {
      type: Boolean,
      default: false,
    },

    validations: {
      type: Object,
      default: null,
    },

    clearable: {
      type: Boolean,
      default: true,
    },

    height: {
      type: [Number, String],
      default: 56,
    },
  },

  data() {
    return {
      Icon,
      search: null,
      select: '',
      loading: false,
      timerId: null,
    };
  },

  watch: {
    search(val) {
      if (
        val !== this.select &&
        !this.items.find((item) => item[this.itemText] === val)
      ) {
        this.emitSearch(val);
      }
    },

    value: {
      immediate: true,
      handler() {
        this.select = this.value;
      },
    },
  },

  methods: {
    emitSearch(query) {
      this.loading = true;
      clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        this.$emit('search', query);
        this.loading = false;
      }, 1000);
    },

    remove(item) {
      const index = this.select.indexOf(item.id);
      if (index >= 0) this.select = this.select.filter((v) => v !== item.id);

      this.handleInput();
    },

    resetInput() {
      this.search = null;
      this.$forceUpdate();
    },

    handleInput() {
      this.search = null;

      this.$emit('input', this.select ?? null);
    },
  },
};
